/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { CalendarModel } from '../../resources';

export interface SupplierOrderInfoDialogConfig {
  date: Date;
  orders: CalendarModel[];
}

@Component({
  selector: 'gh-supplier-order-info-dialog',
  templateUrl: 'supplier-order-info-dialog.component.html',
  styleUrls: ['supplier-order-info-dialog.component.scss'],
})
export class SupplierOrderInfoDialogComponent implements DialogInput<SupplierOrderInfoDialogConfig> {
  input: SupplierOrderInfoDialogConfig;

  get date(): Date {
    return this.input.date;
  }

  get orders(): CalendarModel[] {
    return this.input.orders;
  }

  constructor(private dialogRef: MatDialogRef<any>) {
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

export const supplierOrderInfoDialogRoute = createDialogRoute({
  component: SupplierOrderInfoDialogComponent,
});
